import css from './table.module.css'

import type { TableOverflow } from './table.types'

export const styles = {
  wrapper: css.wrapper,
  table: css.table,
}

export const wrapperOverflowStyles: Record<TableOverflow, string> = {
  scroll: css.wrapperScroll,
  'fit-parent': css.wrapperFitParent,
}

export const tableOverflowStyles: Record<TableOverflow, string> = {
  scroll: css.tableScroll,
  'fit-parent': css.tableFitParent,
}
